var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ArtworksPreview", {
    attrs: {
      selectedArtworks: _vm.selectedArtworks,
      allArtworks: _vm.allArtworks,
      isSelectable: "",
    },
    on: { change: ($e) => _vm.$emit("change", $e) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }